document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-jp-quick-add]');
  if (!button || button.disabled) return;

  event.preventDefault();
  event.stopPropagation();
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');

  try {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') throw new Error('Cart drawer is unavailable');
    if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(button);

    const addResponse = await fetch(`${window.routes.cart_add_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
      },
      body: JSON.stringify({ items: [{ id: Number(button.dataset.jpQuickAdd), quantity: 1 }] }),
    });
    const addedItem = await addResponse.json();
    if (!addResponse.ok || addedItem.status) {
      throw new Error(addedItem.description || addedItem.message || 'Unable to add this item');
    }

    const sectionsResponse = await fetch(`${window.routes.cart_url}?sections=cart-drawer,cart-icon-bubble`, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });
    if (!sectionsResponse.ok) throw new Error('Unable to refresh cart');
    addedItem.sections = await sectionsResponse.json();
    drawer.classList.remove('is-empty');
    drawer.renderContents(addedItem);
  } catch (error) {
    console.error(error);
  } finally {
    button.disabled = false;
    button.removeAttribute('aria-busy');
  }
});
